module.exports = __webpack_public_path__ + "static/media/sfFormula.392b3bd2.png";